var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chat-input" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.thoughtsVisible,
            expression: "thoughtsVisible",
          },
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.thoughtQuestionLoading,
            expression: "thoughtQuestionLoading",
          },
        ],
        staticClass: "thoughts",
      },
      _vm._l(_vm.thoughtQuestions, function (item, index) {
        return _c("div", {
          key: index,
          staticClass: "thoughts-item",
          domProps: { innerHTML: _vm._s(item.highlightText) },
          on: {
            click: function ($event) {
              return _vm.onSelectQuestion(item.rawText)
            },
          },
        })
      }),
      0
    ),
    _c(
      "div",
      {
        staticClass: "chat-textarea-wrap",
        class: { focus: _vm.focus, "multi-line": _vm.textareaHeight > 52 },
      },
      [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.question,
              expression: "question",
            },
          ],
          ref: "textarea",
          staticClass: "chat-textarea",
          attrs: {
            rows: "1",
            maxlength: "2000",
            placeholder: "请描述你的问题 Enter发送，Shift + Enter 换行",
          },
          domProps: { value: _vm.question },
          on: {
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.onKeyDown.apply(null, arguments)
            },
            input: [
              function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.question = $event.target.value
              },
              _vm.onInput,
            ],
            focus: function ($event) {
              _vm.focus = true
            },
            blur: _vm.onBlur,
          },
        }),
        _vm.isShowSend
          ? _c(
              "yxt-tooltip",
              {
                attrs: {
                  content: "暂时不能发送，请稍后再试！",
                  placement: "top",
                  effect: "light",
                  "popper-class": "ai-box-tooltip-peak",
                  disabled: !_vm.loading,
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "send-btn hand",
                    class: { "disbale-send": _vm.loading },
                    on: {
                      click: function ($event) {
                        _vm.loading ? null : _vm.$emit("send", _vm.question)
                      },
                    },
                  },
                  [
                    _c("yxtf-svg", {
                      attrs: {
                        width: "20px",
                        height: "20px",
                        "remote-url": _vm.ICON_PATH,
                        "icon-class": "airplane1",
                      },
                    }),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }